export var FlowProducedType;
(function (FlowProducedType) {
    FlowProducedType["AdvancedFhirResponse"] = "AdvancedFhirResponse";
    FlowProducedType["AgentConversation"] = "AgentConversation";
    FlowProducedType["Any"] = "Any";
    FlowProducedType["Appointments"] = "Appointments";
    FlowProducedType["Conditions"] = "Conditions";
    FlowProducedType["Coverages"] = "Coverages";
    FlowProducedType["DocumentBinaries"] = "DocumentBinaries";
    FlowProducedType["DocumentExtract"] = "DocumentExtract";
    FlowProducedType["DocumentMetadata"] = "DocumentMetadata";
    FlowProducedType["DocumentSearch"] = "DocumentSearch";
    FlowProducedType["Encounter"] = "Encounter";
    FlowProducedType["EncounterSummary"] = "EncounterSummary";
    FlowProducedType["Encounters"] = "Encounters";
    FlowProducedType["Evaluation"] = "Evaluation";
    FlowProducedType["ExternalDocumentPacket"] = "ExternalDocumentPacket";
    FlowProducedType["FhirPatientResponse"] = "FhirPatientResponse";
    FlowProducedType["FileReference"] = "FileReference";
    FlowProducedType["HccSkill"] = "HccSkill";
    FlowProducedType["HumanTask"] = "HumanTask";
    FlowProducedType["InformationExtraction"] = "InformationExtraction";
    FlowProducedType["InsuranceCard"] = "InsuranceCard";
    FlowProducedType["Insurances"] = "Insurances";
    FlowProducedType["LabValues"] = "LabValues";
    FlowProducedType["ListOfObjects"] = "ListOfObjects";
    FlowProducedType["Medications"] = "Medications";
    FlowProducedType["OcrDetailResponse"] = "OcrDetailResponse";
    FlowProducedType["Patient"] = "Patient";
    FlowProducedType["PatientFindings"] = "PatientFindings";
    FlowProducedType["PatientOrder"] = "PatientOrder";
    FlowProducedType["PdsBookedAppointments"] = "PdsBookedAppointments";
    FlowProducedType["PdsConditions"] = "PdsConditions";
    FlowProducedType["PdsCoverages"] = "PdsCoverages";
    FlowProducedType["PdsDocumentBinaries"] = "PdsDocumentBinaries";
    FlowProducedType["PdsDocumentMetadata"] = "PdsDocumentMetadata";
    FlowProducedType["PdsDocumentSearchResults"] = "PdsDocumentSearchResults";
    FlowProducedType["PdsDocumentTranscriptions"] = "PdsDocumentTranscriptions";
    FlowProducedType["PdsEncounters"] = "PdsEncounters";
    FlowProducedType["PdsLabValues"] = "PdsLabValues";
    FlowProducedType["PdsMedications"] = "PdsMedications";
    FlowProducedType["PdsOrders"] = "PdsOrders";
    FlowProducedType["PdsPractitioners"] = "PdsPractitioners";
    FlowProducedType["PdsSurgicalHistories"] = "PdsSurgicalHistories";
    FlowProducedType["Practitioner"] = "Practitioner";
    FlowProducedType["Procedures"] = "Procedures";
    FlowProducedType["Provider"] = "Provider";
    FlowProducedType["SendEmail"] = "SendEmail";
    FlowProducedType["ServiceRequests"] = "ServiceRequests";
    FlowProducedType["ServiceReview"] = "ServiceReview";
    FlowProducedType["Start"] = "Start";
    FlowProducedType["SubFlowV1Result"] = "SubflowResult";
    FlowProducedType["SurgicalHistories"] = "SurgicalHistories";
    FlowProducedType["UpdateFlowConfigData"] = "UpdateFlowConfigData";
    FlowProducedType["VoiceCall"] = "VoiceCall";
    FlowProducedType["VoiceCallV2"] = "VoiceCallV2";
    FlowProducedType["VoiceTranscribe"] = "VoiceTranscribe";
    /**
     * Permanently obsolete blocks. These can never execute.
     */
    /** @deprecated
     * legacy Labelbox enums. We no longer support Labelbox, but if any runs have these types, the schema should still validate.
     */
    FlowProducedType["ObsoleteLabelboxAnnotations"] = "LabelboxAnnotations";
    /** @deprecated
     * legacy Labelbox enums. We no longer support Labelbox, but if any runs have these types, the schema should still validate.
     */
    FlowProducedType["ObsoleteLabelboxReviewResult"] = "LabelboxReviewResult";
})(FlowProducedType || (FlowProducedType = {}));
//# sourceMappingURL=producedType.js.map